export const name = "TIMESTAMP_SUB";
export const summary = `Subtracts a specified time interval from a \`TIMESTAMP\` value.`;
export const reference = `
## TIMESTAMP_SUB

Subtracts a specified time interval from a \`TIMESTAMP\` value.

\`\`\`
TIMESTAMP_SUB(timestamp_expression, INTERVAL int64_expression date_part)
\`\`\`

### Description

Subtracts \`int64_expression\` units of \`date_part\` from the timestamp, independent of any time zone.

\`TIMESTAMP_SUB\` supports the following values for \`date_part\`:

- \`MICROSECOND\`
- \`MILLISECOND\`
- \`SECOND\`
- \`MINUTE\`
- \`HOUR\`. Equivalent to 60 \`MINUTE\` parts.
- \`DAY\`. Equivalent to 24 \`HOUR\` parts.


### Return Data Type

\`TIMESTAMP\`


### Example



\`\`\`
SELECT
  TIMESTAMP("2008-12-25 15:30:00+00") AS original,
  TIMESTAMP_SUB(TIMESTAMP "2008-12-25 15:30:00+00", INTERVAL 10 MINUTE) AS earlier;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------+-------------------------*
 | original | earlier |
 +-------------------------+-------------------------+
 | 2008-12-25 15:30:00 UTC | 2008-12-25 15:20:00 UTC |
 *-------------------------+-------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
